import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useCompany } from 'zens-store'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  title?: string
  companyId: number
  breadcrumbItems?: BreadcrumbData[]
}

const CompanyHeader = (props: Props) => {
  const { title, companyId, breadcrumbItems, style, ...otherProps } = props
  const company = useCompany({ companyId })

  const breadcrumb = useBreadcrumb([
    {
      title: company.data?.name || '',
      href: `/companies/${companyId}/detail`,
    },
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={title || company.data?.name || ' '}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

export default CompanyHeader
